import "core-js/modules/es6.regexp.split";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/* eslint-disable */
import request from '@/utils/request';
export function get(dictName) {
  var params = {
    dictName: dictName,
    page: 0,
    size: 9999
  };
  return request({
    url: 'api/dictDetail',
    method: 'get',
    params: params
  });
}

/**
 * 批量获取字典
 *
 * @param dictName {string}
 * @return {Promise<{dict: {}, label}|{dict: {}, label: {}}>}
 */
export function getDictMap(_x) {
  return _getDictMap.apply(this, arguments);
}
function _getDictMap() {
  _getDictMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dictName) {
    var params, data, dict, label, _loop, key, names, _dict, _label;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (dictName) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", {
            dict: {},
            label: {}
          });
        case 2:
          _context2.prev = 2;
          params = {
            dictName: dictName,
            page: 0,
            size: 9999
          };
          _context2.next = 6;
          return request({
            url: 'api/dictDetail/map',
            method: 'get',
            params: params
          });
        case 6:
          data = _context2.sent;
          dict = data || {};
          label = {};
          _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
            var labels;
            return _regeneratorRuntime().wrap(function _loop$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  labels = {};
                  dict[key] = dict[key].map(function (option) {
                    var value = option.value;
                    if (parseInt(option.value).toString() !== 'NaN') {
                      value = parseInt(option.value);
                    }
                    labels[value] = option.label;
                    return _objectSpread(_objectSpread({}, option), {}, {
                      value: value
                    });
                  });
                  label[key] = labels;
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          _context2.t0 = _regeneratorRuntime().keys(dict);
        case 11:
          if ((_context2.t1 = _context2.t0()).done) {
            _context2.next = 16;
            break;
          }
          key = _context2.t1.value;
          return _context2.delegateYield(_loop(), "t2", 14);
        case 14:
          _context2.next = 11;
          break;
        case 16:
          return _context2.abrupt("return", {
            dict: dict,
            label: label
          });
        case 19:
          _context2.prev = 19;
          _context2.t3 = _context2["catch"](2);
          names = dictName.split(',');
          _dict = {};
          _label = {};
          names.forEach(function (name) {
            _dict[name] = [];
            _label[name] = {};
          });
          return _context2.abrupt("return", {
            dict: _dict,
            label: _label
          });
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[2, 19]]);
  }));
  return _getDictMap.apply(this, arguments);
}
export function add(data) {
  return request({
    url: 'api/dictDetail',
    method: 'post',
    data: data
  });
}
export function del(id) {
  return request({
    url: 'api/dictDetail/' + id,
    method: 'delete'
  });
}
export function edit(data) {
  return request({
    url: 'api/dictDetail',
    method: 'put',
    data: data
  });
}
export default {
  get: get,
  getDictMap: getDictMap,
  add: add,
  edit: edit,
  del: del
};